import {ChangeDetectionStrategy, Component, InputSignal, Signal, computed, inject, input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FormDropdownComponent} from '../../../../shared/elements/form-dropdown/form-dropdown.component';
import {TranslatePipe} from '../../../../shared/pipes/translate.pipe';
import {LanguageService} from '../../../../shared/services/language.service';
import {PreviewDropdownOption} from '../../../../shared/types/feedback-types/previewDropdownOption.interface';
import {FeedbackStructureQuestionFormQuestion} from '../../feedback-structure-create-update-dialog/feedback-structure-question/feedback-structure-question-form.model';
import {feedbackAnswerControlName, previewOptionLabel} from '../../helpers/feedback-structure-preview-control-names';

@Component({
	selector: 'app-feedback-form-element-dropdown',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [FormDropdownComponent, TranslatePipe],
	template: `
		<div class="ps-md-3">
			<app-form-dropdown
				[fG]="formGroup()"
				[fCN]="answerControlName()"
				[dataSource]="options()"
				[mapping]="{text: 'name', value: 'id'}"
				[placeholder]="'FEEDBACKQUESTIONTYPEDROPDOWN' | translate"
				[errorText]="'INPUTREQUIRED' | translate"
				[hasErrorField]="true"
				[disabled]="disabled()"
			></app-form-dropdown>
		</div>
	`,
})
export class FeedbackFormElementDropdownComponent {
	private languageService: LanguageService = inject(LanguageService);

	public question: InputSignal<FeedbackStructureQuestionFormQuestion> = input.required();
	public formGroup: InputSignal<FormGroup> = input.required();
	public controlNamePrefix: InputSignal<string> = input('preview');
	public disabled: InputSignal<boolean> = input(false);

	public options: Signal<PreviewDropdownOption[]> = computed(() => this.question().options.map((option) => ({
		id: option.position,
		name: previewOptionLabel(option, this.languageService.getTranslationByKey('FEEDBACKANSWER')),
	})));

	public answerControlName(): string {
		return feedbackAnswerControlName(this.question(), this.controlNamePrefix());
	}
}
